// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_nr-5";
export var filledCircle = "_nr-4";
export var historyEntry = "_nr-3";
export var messageSideLeft = "_nr-1";
export var messageSideRight = "_nr-2";
export var orderTrackingCarouselWrapper = "_nr-6";
export var orderTrackingInfoContainer = "_nr-0";